var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2253_101433",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12ZM5.41759 12C5.41759 15.9115 8.58849 19.0824 12.5 19.0824C16.4115 19.0824 19.5824 15.9115 19.5824 12C19.5824 8.08849 16.4115 4.91759 12.5 4.91759C8.58849 4.91759 5.41759 8.08849 5.41759 12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12ZM5.41759 12C5.41759 15.9115 8.58849 19.0824 12.5 19.0824C16.4115 19.0824 19.5824 15.9115 19.5824 12C19.5824 8.08849 16.4115 4.91759 12.5 4.91759C8.58849 4.91759 5.41759 8.08849 5.41759 12Z",
    fill: "white",
    stroke: "#FFB800",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_2253_101433)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 35"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_2253_101433",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C14.8734 2.83022e-08 17.1935 0.703788 19.1668 2.02236C21.1402 3.34094 22.6783 5.21509 23.5866 7.4078C24.4948 9.60051 24.7324 12.0133 24.2694 14.3411C23.8064 16.6689 22.6635 18.8071 20.9853 20.4853C19.3071 22.1635 17.1689 23.3064 14.8411 23.7694C12.5133 24.2324 10.1005 23.9948 7.9078 23.0866C5.71509 22.1783 3.84094 20.6402 2.52236 18.6668C1.20379 16.6935 0.5 14.3734 0.5 12H5.41759C5.41759 13.4008 5.83296 14.7701 6.61119 15.9348C7.38941 17.0995 8.49554 18.0072 9.78968 18.5433C11.0838 19.0793 12.5079 19.2196 13.8817 18.9463C15.2556 18.673 16.5175 17.9985 17.508 17.008C18.4985 16.0175 19.173 14.7556 19.4463 13.3817C19.7196 12.0079 19.5793 10.5838 19.0433 9.28968C18.5072 7.99554 17.5995 6.88941 16.4348 6.11119C15.2701 5.33296 13.9008 4.91759 12.5 4.91759V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C14.8734 2.83022e-08 17.1935 0.703788 19.1668 2.02236C21.1402 3.34094 22.6783 5.21509 23.5866 7.4078C24.4948 9.60051 24.7324 12.0133 24.2694 14.3411C23.8064 16.6689 22.6635 18.8071 20.9853 20.4853C19.3071 22.1635 17.1689 23.3064 14.8411 23.7694C12.5133 24.2324 10.1005 23.9948 7.9078 23.0866C5.71509 22.1783 3.84094 20.6402 2.52236 18.6668C1.20379 16.6935 0.5 14.3734 0.5 12H5.41759C5.41759 13.4008 5.83296 14.7701 6.61119 15.9348C7.38941 17.0995 8.49554 18.0072 9.78968 18.5433C11.0838 19.0793 12.5079 19.2196 13.8817 18.9463C15.2556 18.673 16.5175 17.9985 17.508 17.008C18.4985 16.0175 19.173 14.7556 19.4463 13.3817C19.7196 12.0079 19.5793 10.5838 19.0433 9.28968C18.5072 7.99554 17.5995 6.88941 16.4348 6.11119C15.2701 5.33296 13.9008 4.91759 12.5 4.91759V0Z",
    fill: "#FFB800",
    stroke: "#FFB800",
    strokeWidth: 2,
    mask: "url(#path-2-inside-2_2253_101433)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 12.5,
    cy: 12,
    r: 5,
    fill: "#FFB800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInProgress);
export default __webpack_public_path__ + "static/media/status_in_progress.6f9b6db6cea06e6e37fec416898f4003.svg";
export { ForwardRef as ReactComponent };